import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

const PLATTFORMEN = [
  {
    name: 'Google Bewertungen',
    beschreibung: 'Öffentliche Bewertungen auf Google My Business.',
    url: null
  },
  {
    name: 'ProvenExpert',
    beschreibung: 'Verifizierte Kundenbewertungen auf ProvenExpert.',
    url: null
  }
];

export const PlattformenUebersicht = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Plattformen
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wo Sie unsere Bewertungen finden
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {PLATTFORMEN.map((plattform, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-3xl p-10 shadow-lg hover:shadow-xl transition-all duration-300">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{plattform.name}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{plattform.beschreibung}</p>
              
              {plattform.url ? (
                <a href={plattform.url} target="_blank" rel="noopener noreferrer">
                  <Button className="bg-brand-green hover:bg-brand-green-dark text-white font-semibold px-6 py-3 rounded-xl">
                    <ExternalLink className="w-4 h-4 mr-2" />
                    Zu {plattform.name.split(' ')[0]}
                  </Button>
                </a>
              ) : (
                <Button disabled className="bg-gray-200 text-gray-500 font-semibold px-6 py-3 rounded-xl cursor-not-allowed">
                  Link wird eingebunden
                </Button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};